import { AnticipatedMonthlySpend, NetWorths, SourceOfWealth } from './api';

export class Constants {
  static NET_WORTHS: NetWorths = {
    upTo1million: 'Up to 1 million',
    from1to8mln: 'From 1 to 8 million',
    from8to15mln: 'From 8 to 15 million',
    moreThan15mln: 'More than 15 million',
  };

  static ANTICIPATED_MONTHLY_SPENDS: Partial<{ [key in AnticipatedMonthlySpend]: string }> = {
    UpTo10k: '0-10K',
    from10001To30000: '10K-30K',
    from30001To70000: '30K-70K',
    from70001To200000: '70K-200K',
    Above200k: '200,000+',
  };

  static SOURCES_OF_WEALTH: { [key in SourceOfWealth]: string } = {
    Employment: 'Employment income',
    Savings: 'Savings',
    FamilyWealth: 'Family wealth',
    Inheritance: 'Inheritance',
    Business: 'Business earnings',
    SalesOfAssets: 'Sales of assets',
    Guarantor: 'Guarantor',
  };
}
